import { makeStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';

export const useStyles = makeStyles(() =>
  createStyles({
    closeIcon: {
      borderRadius: '20px',
      width: '15px',
      color: 'rgba(44, 45, 62, 0.8)',
      '&:hover': {
        backgroundColor: '#EFDADA',
      },
    },
    howToRegIcon: {
      width: '13px',
      height: '11px',
      marginRight: '5px',
    },
  }),
);

export const ExaminersTreeButton = withStyles(() => ({
  root: {
    display: 'flex',
    height: 'auto',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontSize: '1rem',
    textTransform: 'capitalize',
    color: '#2C2D3E',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    zIndex: 10,
    padding: '5px',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
}))(Button);

export const EmptyExaminersTreeButton = withStyles(() => ({
  root: {
    display: 'flex',
    height: '30px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontSize: '12px',
    lineHeight: '14px',
    textTransform: 'capitalize',
    color: '#3C419A',
    border: 'solid 1px rgba(44, 45, 62, 0.3)',
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    zIndex: 10,
    padding: '10px',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
}))(Button);
